import React, { useEffect,useState, useContext } from 'react';
import Typography from '@mui/material/Typography';
import { postJSONPS } from '@cd/utils';
import { store } from './store';
import { either } from '@cd/utils';
import ReactMarkdown from 'react-markdown';

const TermsAndConditions = () => {
	const { dispatch } = useContext(store);
	const [text, setText] = useState('');
	useEffect(() => {
		postJSONPS('GET', '/general/termsandconditions').then(
			either(e => dispatch({ type: 'post error', e }), setText)
		);
	}, []);
	return (
		<Typography variant="body1" display="block" color="inherit">
			<ReactMarkdown>{text}</ReactMarkdown>
		</Typography>
	);
};

export default TermsAndConditions;
